import React from 'react';
import PropTypes from 'prop-types';

import MusicServicesList
  from 'components/dashboard/music-links-content/MusicServicesList';
import AddMusicServiceItemForm
  from 'components/dashboard/music-links-content/AddMusicServiceItemForm';

import './MusicLinkItemExpandedContent.css';

function MusicLinkItemExpandedContent({ item }) {
  return (
    <div className="music-link-item-expanded-content__component">
      <MusicServicesList item={item} />
      <AddMusicServiceItemForm item={item} />
    </div>
  );
}

MusicLinkItemExpandedContent.propTypes = {
  item: PropTypes.object.isRequired,
};

export default MusicLinkItemExpandedContent;
